import { actions as termsActions } from 'core/logic/terms/terms.reducer'
import { call, put } from 'redux-saga/effects'
import * as termsService from './terms.service'
import { TermsType } from './terms.types'
import { errorToMessage } from 'utility/service-errors'

export function* startTermsFetch() {
  try {
    yield put(termsActions.fetchTerms())
    const result: TermsType = yield call(termsService.fetchTerms)
    yield put(termsActions.fetchTermsSuccess(result))
  } catch (e) {
    yield put(termsActions.fetchTermsFailed(errorToMessage(e, 'terms.fetch')))
  }
}
